import React from "react";
import PropTypes from "prop-types";
import { ComparisonTabs } from "./ComparisonTabs";
import { ComparisonBlock } from "./ComparisonBlock";
import { TAB_LIST, TAB_STATE } from "./ResultComparison.constants";
import "./style.scss";

/**
 * ResultComparison
 *  - Component lets you compare between Predicted, Actual and Ideal States of components.
 */
export function ResultComparison(props) {
  const tabListDefault = TAB_LIST;
  if (props.predictedState.label) {
    tabListDefault[0].label = props.predictedState.label;
  }
  if (props.actualState.label) {
    tabListDefault[1].label = props.actualState.label;
  }
  if (props.idealState.label) {
    tabListDefault[2].label = props.idealState.label;
  }

  const [tabList, updateTabList] = React.useState(tabListDefault);

  const [compareBlockProps, setCompareBlockProps] = React.useState({});

  const selectTab = (tabValue) => {
    const updatedTabList = updateTabListStates(tabList, tabValue);
    updateTabList(updatedTabList);
  };

  const makeCompareBlockProps = () => {
    const teritaryTab = tabList.find((tab) => tab.state === TAB_STATE.TERITARY);
    let leftSection = props.predictedState;
    let rightSection = props.actualState;
    if (teritaryTab.value === TAB_LIST[0].value) {
      leftSection = props.actualState;
      rightSection = props.idealState;
    }
    if (teritaryTab.value === TAB_LIST[1].value) {
      rightSection = props.idealState;
    }
    setCompareBlockProps({ leftSection, rightSection, hasCaption: !!props.caption });
  };

  const setAriaLabel = (props, tabList) => {
    const updatedTabList = setTabsAriaLabel(tabList, props);
    updateTabList(updatedTabList);
  };

  React.useEffect(() => {
    setAriaLabel(props, tabList);
  }, [props]);

  React.useEffect(makeCompareBlockProps, [tabList]);
  return (
    <div
      className={`comparisonWidgetWrapper ${props.caption ? "has-caption" : ""}`}
    >
      <ComparisonTabs tabList={tabList} selectTab={selectTab} />
      <ComparisonBlock {...compareBlockProps} />
      {props.caption && props.caption}
    </div>
  );
}

const ComponentState = PropTypes.shape({
  /**
   * Type of component
   */
  type: PropTypes.string,
  /**
   * React component for the state
   */
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
});

ResultComparison.propTypes = {
  /**
   * Data corresponding to Predicted State
   */
  predictedState: ComponentState,
  /**
   * Data Corresponding to Actual State
   */
  actualState: ComponentState,
  /**
   * Data corresponding to Ideal State
   */
  idealState: ComponentState,
};

ResultComparison.defultProps = {};

function updateTabListStates(tabList, selectedTabValue) {
  const selectedTab = tabList.find((tab) => tab.value === selectedTabValue);
  if (selectedTab.state === TAB_STATE.PRIMARY) {
    return tabList;
  } else {
    return tabList.map((tab) => {
      if (tab.value === selectedTabValue) {
        return { ...tab, state: TAB_STATE.PRIMARY };
      } else if (tab.state === TAB_STATE.PRIMARY) {
        return { ...tab, state: TAB_STATE.SECONDARY };
      } else if (tab.state === TAB_STATE.SECONDARY) {
        return { ...tab, state: TAB_STATE.TERITARY };
      } else {
        return { ...tab };
      }
    });
  }
}

function setTabsAriaLabel(tabList, data) {
  const updatedTabList = tabList.map((list) => {
    if (list.value === "actual") {
      const actualState = data.actualState.headingAriaLabel;
      return { ...list, ariaLabel: actualState };
    } else if (list.value === "predicted") {
      const predictedState = data.predictedState.headingAriaLabel;
      return { ...list, ariaLabel: predictedState };
    } else if (list.value === "ideal") {
      const idealState = data.idealState.headingAriaLabel;
      return { ...list, ariaLabel: idealState };
    } else {
      return list;
    }
  });
  return updatedTabList;
}
